(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_header"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init=()=>{
  const header=document.getElementById('CustomStickyHeader');
  if(!header||header.dataset.initialized)return;
  header.dataset.initialized='true';
  const content=header.querySelector('.custom-sticky-header__content');
  const toggle=header.querySelector('#StickyNavToggle');
  const drawer=header.querySelector('#StickyNavDrawer');
  const wrapper=document.querySelector('.page-wrapper');
  const loadMenuPhoto=async()=>{
   const count=Number(drawer.dataset.productCount),base=drawer.dataset.root||'/';
   if(!count)return;
   try{
    for(let attempt=0;attempt<3;attempt++){
     const page=1+Math.floor(Math.random()*Math.ceil(count/250));
     const response=await fetch(base+'products.json?limit=250&page='+page);
     if(!response.ok)return;
     const data=await response.json();
     const products=(data.products||[]).filter(product=>product.images?.length);
     if(!products.length)continue;
     const product=products[Math.floor(Math.random()*products.length)];
     const url=new URL(product.images[0].src,location.origin);url.searchParams.set('width','1800');
     const photo=new Image();photo.src=url.href;await photo.decode();
     if(drawer.isConnected)drawer.style.setProperty('--tcg-menu-photo','url('+JSON.stringify(photo.src)+')');
     return;
    }
   }catch(error){}
  };
  loadMenuPhoto();
  const syncHeight=()=>document.documentElement.style.setProperty('--tcg-header-height',content.getBoundingClientRect().height+'px');
  syncHeight();if('ResizeObserver' in window)new ResizeObserver(syncHeight).observe(content);
  const onScroll=()=>header.classList.toggle('is-scrolled',Math.max(window.scrollY,wrapper?.scrollTop||0)>100);
  window.addEventListener('scroll',onScroll,{passive:true});wrapper?.addEventListener('scroll',onScroll,{passive:true});onScroll();
  let savedRoot='',savedWrapper='';
  const setOpen=(open)=>{
   const previous=toggle.getAttribute('aria-expanded')==='true';
   if(previous===open)return;
   toggle.setAttribute('aria-expanded',String(open));drawer.inert=!open;drawer.classList.toggle('is-open',open);header.classList.toggle('is-open',open);
   if(open){savedRoot=document.documentElement.style.overflow;savedWrapper=wrapper?.style.overflow||'';document.documentElement.style.overflow='hidden';if(wrapper)wrapper.style.overflow='hidden';requestAnimationFrame(()=>drawer.querySelector('a')?.focus());}
   else{document.documentElement.style.overflow=savedRoot;if(wrapper)wrapper.style.overflow=savedWrapper;toggle.focus();}
  };
  toggle.addEventListener('click',()=>setOpen(toggle.getAttribute('aria-expanded')!=='true'));
  drawer.addEventListener('click',e=>{const link=e.target.closest('a');if(!link)return;setOpen(false);if(link.matches('[data-tcg-search]')){const modal=document.getElementById('search-modal');if(typeof modal?.showDialog==='function'){e.preventDefault();modal.showDialog();modal.addEventListener('dialog:close',()=>toggle.focus(),{once:true});}}});
  header.addEventListener('keydown',e=>{
   if(toggle.getAttribute('aria-expanded')!=='true')return;
   if(e.key==='Escape'){e.preventDefault();setOpen(false);return;}
   if(e.key==='Tab'){
    const nodes=[toggle,...drawer.querySelectorAll('a[href],button')];const current=nodes.indexOf(document.activeElement);
    e.preventDefault();nodes[(current+(e.shiftKey?-1:1)+nodes.length)%nodes.length]?.focus();
   }
  });
 };
 init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcg-artists"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=()=>{document.querySelectorAll('[data-artist-directory]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const cards=[...root.querySelectorAll('[data-artist]')];const input=root.querySelector('[data-artist-search]'),status=root.querySelector('[data-artist-status]'),more=root.querySelector('[data-artist-more]');const normalize=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]/g,'');cards.sort((a,b)=>a.dataset.artist.localeCompare(b.dataset.artist));const grid=root.querySelector('.tcg-artist-grid');cards.forEach(c=>grid.append(c));let limit=48;const update=()=>{const query=normalize(input.value);let count=0;cards.forEach(card=>{const match=normalize(card.dataset.artist).includes(query);card.hidden=!match||count>=limit;if(match)count++});status.textContent=status.dataset.pattern.replace('[count]',count);more.hidden=count<=limit;root.querySelector('[data-artist-empty]').hidden=count>0};root.querySelector('[data-artist-search-form]').addEventListener('submit',event=>{event.preventDefault();limit=48;update()});input.addEventListener('input',()=>{limit=48;update()});more.addEventListener('click',()=>{limit+=48;update()});update()})};init();document.addEventListener('shopify:section:load',init)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcg-random-feature"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=()=>document.querySelectorAll('[data-random-feature]').forEach(async root=>{if(root.dataset.ready)return;root.dataset.ready='true';const count=Number(root.dataset.count),base=root.dataset.root||'/';if(!count)return;try{let chosen;for(let attempt=0;attempt<5&&!chosen;attempt++){const page=1+Math.floor(Math.random()*Math.ceil(count/250));const response=await fetch(`${base}products.json?limit=250&page=${page}`);if(!response.ok)break;const data=await response.json();const products=(data.products||[]).filter(p=>p.variants?.some(v=>v.available)&&p.images?.length);if(products.length)chosen=products[Math.floor(Math.random()*products.length)]}if(!chosen)return;const response=await fetch(`${base}products/${encodeURIComponent(chosen.handle)}.js`);if(!response.ok)return;const product=await response.json();if(!product.available||!root.isConnected)return;const img=root.querySelector('.tcg-feature-media img');if(!img)return;const image=new Image();image.src=product.featured_image;await image.decode();img.removeAttribute('srcset');img.src=image.src;img.alt=product.title;root.querySelectorAll('[data-feature-link]').forEach(a=>a.href=base+'products/'+product.handle);root.querySelector('[data-feature-title]').textContent=product.title;root.querySelector('[data-feature-price]').textContent=new Intl.NumberFormat(root.dataset.locale,{style:'currency',currency:root.dataset.currency}).format(product.price/100);const description=new DOMParser().parseFromString((product.description||'').replace(/<\/(p|div|li|h[1-6])>|<br\s*\/?>/gi,' '),'text/html').body.textContent.replace(/\s+/g,' ').trim();root.querySelector('[data-feature-description]').textContent=description.length>360?description.slice(0,357)+'…':description;}catch(error){}});if('IntersectionObserver'in window){const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){init();observer.disconnect()}},{rootMargin:'800px'});document.querySelectorAll('[data-random-feature]').forEach(el=>observer.observe(el))}else init();document.addEventListener('shopify:section:load',init)})();

  } catch(e) { console.error(e); }
})();
})();
